<template>
  <div>
    <div
      class="flex-display ai-center color-bg-primary-lighter border-radius-small pd-4"
    >
      <div v-if="showEditor == false">
        <div class="box-image">
          <avatar
            :rounded="false"
            :username="`${user.nameTH} ${user.surnameTH}`"
            :src="`${urlImage}${user.userId}/${user.profileImg}`"
            :size="40"
          >
          </avatar>
        </div>
      </div>
      <div class="pd-l-4 width-100">
        <el-form label-position="top" :model="form" :rules="rules" ref="form">
          <el-form-item label="" class="mg-b-less">
            <el-input
              v-if="showEditor == false"
              placeholder="แสดงความคิดเห็น...."
              @focus="showEditor = true"
              class="round"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="showEditor == true" label="" prop="comment">
            <yimo-vue-editor
              v-if="showEditor == true"
              v-model="form.comment"
              @input="checkValid('comment')"
            ></yimo-vue-editor>
          </el-form-item>
          <el-form-item v-if="showEditor == true" label="" class="text-right">
            <el-button @click="showEditor = false" type="text"
              ><span class="color-gray">ยกเลิก</span></el-button
            >
            <el-button
              @click="createDiscussionForumReply"
              :loading="loading"
              type="primary"
              ><span class="pd-x-4">เพิ่ม</span></el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <p class="text-font-12 text-right">
      ตัวอักษรอย่างน้อย {{ form.comment.length }}/20 ตัวอักษร
    </p>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import { nbspRem } from "@/service/editor";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    Avatar,
  },
  props: {
    discussionId: {
      type: String,
      default() {
        return "";
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    var validateRangeComment = (rule, value, callback) => {
      if (value.length < 20) {
        callback(new Error("กรุณากรอกความคิดเห็นอย่างน้อย 20 ตัวอักษร"));
      } else {
        callback();
      }
    };
    return {
      form: {
        comment: "",
      },
      rules: {
        comment: [
          {
            required: true,
            message: "กรุณากรอกความคิดเห็น",
            trigger: "blur",
          },
          { validator: validateRangeComment, trigger: "blur" },
        ],
      },
      showEditor: false,
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
      loading: false,
    };
  },
  methods: {
    createDiscussionForumReply() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;

          let obj = {
            type: "reply",
            courseId: this.courseId,
            discussionId: this.discussionId,
            text: this.form.comment,
          };

      
          HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
          HTTP.post(`take`, obj)
            .then((res) => {
              if (res.data.success) {
                this.$emit("fetchDiscussionId");
                this.form.comment = "";
                this.showEditor = false;
              } else {
                this.alertFailError();
              }
            })
            .catch((e) => {
              this.alertCatchError(e);
              console.log("createDiscussionForum error", e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    checkValid(field) {
      if (this.$options.filters.striphtml(this.form.comment) == "") {
        this.form.comment = "";
      }
      this.$refs["form"].validateField(field);
    },
  },
};
</script>

<style scoped></style>
